import type { FeatureFlagsState } from '@stores/features-flags/features-flags-ngrx.reducer';

import { createSelector } from '@ngrx/store';
import { featureFlagsKey } from '@stores/features-flags/features-flags-ngrx.reducer';

export const selectFeatureFlagsState = (state: any): FeatureFlagsState => state[featureFlagsKey];

export const featureFlagList = createSelector(selectFeatureFlagsState, (state) => {
  return state.featureFlags;
});
export const secureSpaceEnabled = createSelector(selectFeatureFlagsState, (state) => {
  return state.featureFlags?.includes('secureSpace');
});
export const trustpilotEnabled = createSelector(selectFeatureFlagsState, (state) => {
  return state.featureFlags?.includes('trustpilot');
});
export const blogAdvicesEnabled = createSelector(selectFeatureFlagsState, (state) => {
  return state.featureFlags?.includes('advices');
});
export const blogFinancialAidEnabled = createSelector(selectFeatureFlagsState, (state) => {
  return state.featureFlags?.includes('financialAid');
});
export const blogFaqEnabled = createSelector(selectFeatureFlagsState, (state) => {
  return state.featureFlags?.includes('faq');
});
